import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-table-root': {
    '.abyss-table-body': {
      '.abyss-table-row': {
        'td:first-child': {
          flex: 'none !important',
          minWidth: '52px !important',
          width: '52px !important',
        },
        'td:last-child': {
          flex: 'none !important',
          minWidth: '150px !important',
          width: '150px !important',
        },
        'td:nth-of-type(2)': {
          flex: 'auto !important',
          minWidth: '15% !important',
          width: '15% !important',
        },
        'td:nth-of-type(3)': {
          flex: 'auto !important',
          minWidth: '50% !important',
          width: '50% !important',
        },
      },
    },
    '.abyss-table-head': {
      '.abyss-table-header': {
        'th:first-child': {
          flex: 'none !important',
          minWidth: '52px !important',
          width: '52px !important',
        },
        'th:last-child': {
          flex: 'none !important',
          minWidth: '150px !important',
          width: '150px !important',
        },
        'th:nth-of-type(2)': {
          flex: 'auto !important',
          minWidth: '15% !important',
          width: '15% !important',
        },
        'th:nth-of-type(3)': {
          flex: 'auto !important',
          minWidth: '50% !important',
          width: '50% !important',
        },
      },
    },
  },
});
